exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie[data-v-ed755df2] {\n  z-index: 2;\n  bottom: 0;\n}\n.icon[data-v-ed755df2]:hover {\n  color: #000;\n  background-color: #8e8e8e;\n}\n", ""]);

// exports
